import { MemberSubmissionTypeEnum } from '../../../../../../models/users/enum/member-submission-type-enum';
import { SubmissionPermissionUtils } from '../../../../../../utils/submission-permission-utils';
import { InternalUserSubmissionPermissionParentFormGroup } from '../forms/internal-user-submission-permission-parent-form-group';

export class InternalUserSubmissionPermissionFormStateUtils {
  static readonly PERMANENTLY_DISABLED_IDS: number[] = [
    SubmissionPermissionUtils.getCanApproveOwnMemberSubmissionPermission(
      MemberSubmissionTypeEnum.VariableBenefitConfiguration
    ),
    SubmissionPermissionUtils.getCanApproveOwnMemberSubmissionPermission(MemberSubmissionTypeEnum.MonthlyPensionSetup)
  ];

  static readonly ID_DEPENDENCIES: Array<{ id: number; requiresId: number }> = [
    {
      id: SubmissionPermissionUtils.getCanCreateMemberSubmissionPermission(
        MemberSubmissionTypeEnum.VariableBenefitConfiguration
      ),
      requiresId: SubmissionPermissionUtils.getProcessMemberSubmissionPermission(
        MemberSubmissionTypeEnum.VariableBenefitConfiguration
      )
    }
  ];

  static isPermanentlyDisabled(id: number): boolean {
    return InternalUserSubmissionPermissionFormStateUtils.PERMANENTLY_DISABLED_IDS.includes(id);
  }

  static reapplyDisabledState(fg: InternalUserSubmissionPermissionParentFormGroup): void {
    const { memberSubmissions, employerSubmissions } = fg.controls;
    for (const array of [memberSubmissions, employerSubmissions]) {
      for (const typeGroup of array.controls) {
        for (const permGroup of typeGroup.controls.submissionPermissions.controls) {
          if (InternalUserSubmissionPermissionFormStateUtils.isPermanentlyDisabled(permGroup.controls.id.value)) {
            permGroup.disable({ emitEvent: false });
          }
        }
      }
    }
  }
}
